/* global globalThis */
import html2canvas from "html2canvas";
import CryptoJS from "crypto-js";
import moment from "moment";

// 取得 cookie 值
export function getCookie(name) {
  const cookieVal = `; ${document.cookie}`;
  const parts = cookieVal.split(`; ${name}=`);
  if (parts.length >= 2) return parts.pop().split(";").shift();
  return "";
}

// 取得 url search
export function getUrlSearch(name, search) {
  const parts = search.split(`${name}=`);
  if (parts.length >= 2) {
    return parts.pop().split("&")[0];
  }
  return "";
}

export function getQueryData({ isKeyLowerCase = false, str }) {
  const parts = str.split("&");
  return parts.reduce((pre, cur) => {
    let temp = { ...pre },
      [key, val] = cur.split("=");
    if (isKeyLowerCase) key = key.toLowerCase();
    temp[key] = val;
    return temp;
  }, {});
}

// 排除 JSON 資料
export function excludeJSON(data, exclude) {
  let temp = { ...data };
  exclude.forEach((item) => {
    delete temp[item];
  });

  return temp;
}

// 設定 formData 資料
export function formatFormData(data) {
  let formData = new FormData();
  Object.entries(data).forEach(([name, value]) => {
    formData.append(name, value);
  });

  return formData;
}

// 設定回傳資料
export function formatResData(oldData, newData) {
  let temp = structuredClone(oldData);
  Object.entries(temp).forEach(([key, val]) => {
    if (
      newData[key] !== null &&
      newData[key] !== undefined &&
      newData[key] !== ""
    ) {
      temp[key] = newData[key];
    }
  });

  return temp;
}

const isSameFormValue = (rawValue, nextValue) => {
  if (rawValue === nextValue) return true;

  const rawType = typeof rawValue;
  const nextType = typeof nextValue;
  const comparableTypes = new Set(["number", "string", "boolean"]);
  if (
    comparableTypes.has(rawType) &&
    comparableTypes.has(nextType)
  ) {
    const rawNumber = Number(rawValue);
    const nextNumber = Number(nextValue);
    return !Number.isNaN(rawNumber) && rawNumber === nextNumber;
  }

  return false;
};

// 排除obj內無資料的項目
export function cleanObj(data) {
  let temp = {};
  Object.entries(data).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      temp[key] = value;
    }
  });

  return temp;
}

// 轉換options資料
export function formatOptions(
  rawData,
  { uniqueKey = "value", showLabel = "label", childKey = "child" } = {}
) {
  let tempObj = {};

  function formatOption(data, items) {
    items.forEach((item) => {
      item["showLabel"] = item[showLabel];
      item["showValue"] = item[uniqueKey];
      data[item[uniqueKey]] = item;

      if (item[childKey]) {
        formatOption(data, item[childKey]);
      }
    });
  }

  Object.entries(rawData).forEach(([name, value]) => {
    tempObj[`${name}_obj`] = {};
    formatOption(tempObj[`${name}_obj`], value);
  });

  return { ...rawData, ...tempObj };
}

// 確認表單是否更新
export function checkFormUpdate(newData, rawData) {
  return Object.entries(newData).some(([key, val]) => {
    if (
      (rawData[key] === null ||
        rawData[key] === undefined ||
        rawData[key] === "") &&
      (val === null || val === undefined || val === "")
    ) {
      return false;
    }

    return !isSameFormValue(rawData[key], val);
  });
}

// 下載
export function exportFile(url, filename) {
  let ext = url.split(".");
  ext = ext[ext.length - 1];

  let link = document.createElement("a");
  document.body.appendChild(link);
  link.href = url;
  link.download = `${filename}.${ext}`;
  link.target = "_blank";
  link.click();
  link.remove();
}

// 列表 page 參數設定
export function setPageSetting(data) {
  sessionStorage.setItem("pageSetting", JSON.stringify(data));
}

// 取得 列表 page 參數
export function getPageSetting(page) {
  let pageSetting = sessionStorage.getItem("pageSetting");
  if (pageSetting) pageSetting = JSON.parse(pageSetting);
  if (pageSetting && page.includes(pageSetting.page)) return pageSetting;

  return null;
}

// excel 日期傳換
export function parseExcelDateToDate(serial) {
  const utc_days = Math.floor(serial - 25569);
  const utc_value = utc_days * 86400;
  const date_info = new Date(utc_value * 1000);

  const fractional_day = serial - Math.floor(serial) + 0.0000001;

  let total_seconds = Math.floor(86400 * fractional_day);

  const seconds = total_seconds % 60;

  total_seconds -= seconds;

  const hours = Math.floor(total_seconds / (60 * 60));
  const minutes = Math.floor(total_seconds / 60) % 60;

  return new Date(
    date_info.getFullYear(),
    date_info.getMonth(),
    date_info.getDate(),
    hours,
    minutes,
    seconds
  );
}

// 身分證驗證
export function idCardCheck(idCard) {
  //建立字母分數陣列(A~Z)
  let city = [
    1, 10, 19, 28, 37, 46, 55, 64, 39, 73, 82, 2, 11, 20, 48, 29, 38, 47, 56,
    65, 74, 83, 21, 3, 12, 30,
  ];
  idCard = idCard.toUpperCase();
  //使用「正規表達式」檢驗格式
  if (idCard.search(/^[A-Z][1-28-9A-D]\d{8}$/i) === -1) {
    return false;
  } else {
    //將字串分割為陣列(IE必需這麼做才不會出錯)
    let word = idCard.split("");
    let total = 0;
    if (idCard.search(/^[A-Z][1-28-9]\d{8}$/i) !== -1) {
      // 新版身分證
      total = city[word[0].codePointAt(0) - 65];
      for (let i = 1; i <= 8; i++) {
        total += Number(word[i]) * (9 - i);
      }
      //補上檢查碼(最後一碼)
      total += Number(word[9]);
    } else if (idCard.search(/^[A-Z][A-D]\d{8}$/i) !== -1) {
      // 舊版身分證
      let conver = "ABCDEFGHJKLMNPQRSTUVXYWZIO";
      let weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
      idCard =
        String(conver.indexOf(idCard[0]) + 10) +
        String((conver.indexOf(idCard[1]) + 10) % 10) +
        idCard.slice(2);
      word = idCard.split("");
      for (let i = 0; i < word.length; i++) {
        let c = Number.parseInt(word[i], 10);
        let w = weights[i];
        total += c * w;
      }
    }

    if (total % 10 !== 0) {
      return false;
    }
  }
  return true;
}

export function base64DataURLToArrayBuffer(dataURL) {
  const base64Regex = /^data:image\/(png|jpg|svg|jpeg|svg\+xml);base64,/;
  if (!base64Regex.test(dataURL)) {
    return null;
  }
  const stringBase64 = dataURL.replace(base64Regex, "");
  let binaryString;
  if (globalThis.window === undefined) {
    binaryString = Buffer.from(stringBase64, "base64").toString("binary");
  } else {
    binaryString = globalThis.window.atob(stringBase64);
  }
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    const ascii = binaryString.codePointAt(i);
    bytes[i] = ascii;
  }
  return bytes.buffer;
}

// url to base64
export function anyGetBase64(url, callback) {
  let Img = new Image(),
    pngData = "";

  Img.src = url + "?t=" + Date.now(); // 处理缓存,fix缓存bug,有缓存，浏览器会报错;

  Img.setAttribute("crossOrigin", "Anonymous"); // 解决控制台跨域报错的问题

  return new Promise((resolve, reject) => {
    Img.onload = function () {
      //要先确保图片完整获取到，这是个异步事件

      let canvas = document.createElement("canvas"), //创建canvas元素
        width = Img.width, //确保canvas的尺寸和图片一样
        height = Img.height;

      canvas.width = width;

      canvas.height = height;

      canvas.getContext("2d").drawImage(Img, 0, 0, width, height); //将图片绘制到canvas中

      pngData = canvas.toDataURL("image/png"); //转换图片为 pngData

      resolve({
        pngData,
        style: {
          width,
          height,
        },
      });
    };
  });
}

// dataURL to File
export function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].split(":")[1].split(";")[0],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.codePointAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export function dataURLtoBase64(dataURL) {
  return dataURL.replace("data:", "").replace(/^.+,/, "");
}

// 截圖 (html)
export async function convertToCanvas({ targetId }) {
  let target = document.getElementById(targetId);

  return await html2canvas(target, {
    backgroundColor: null,
    allowTaint: true,
    useCORS: true,
  }).then(async (canvas) => {
    let pngData = canvas.toDataURL("image/png");

    let blob = await canvasToBlob(canvas);

    return {
      pngData: pngData,
      file: dataURLtoFile(pngData, "map.png"),
      blob,
    };
  });
}

const canvasToBlob = async (canvas) => {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(blob);
    });
  });
};

export function blobToBase64(blob) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}

export function blobToFile({ blob, fileName }) {
  return new File([blob], fileName, {
    lastModified: Date.now(),
    type: blob.type,
  });
}

// 數字切割(逗號、千分位)
export function splitNumber(number) {
  let [numInteger, numDecimal] = String(number).split("."); // 原數字轉字串
  let tempCount = Math.floor(numInteger.length / 3); // 有幾組3位數
  let tempRemain = numInteger.length % 3; // 多幾位，放逗號左側
  let reStr = "";

  for (let i = 0; i < tempRemain; i++) {
    // 位數不為3的倍數，先將多餘的產生，之後再併逗號產生後續數字
    reStr += String(numInteger[i]);
  }

  for (let i = 0; i < tempCount; i++) {
    if ((tempRemain === 0 && i > 0) || tempRemain !== 0) {
      // 位數為3的倍數，第一組前面不加逗號 || 位數不為3的倍數
      reStr += ",";
    }

    reStr += String(numInteger[tempRemain + 0 + 3 * i]);
    reStr += String(numInteger[tempRemain + 1 + 3 * i]);
    reStr += String(numInteger[tempRemain + 2 + 3 * i]);
  }

  if (tempCount === 0) {
    reStr = number;
  } else if (numDecimal) {
    reStr += `.${numDecimal}`;
  }

  return reStr;
}

// 小數補0
export function decimalAddZero({
  rawVal = 0,
  decimalCount = 0,
  decimalShowRaw = false,
  isZero = true,
} = {}) {
  // 若超出小數點位數，四捨五入
  let pow = Math.pow(10, decimalCount);
  rawVal = decimalShowRaw ? rawVal : Math.round(rawVal * pow) / pow;

  // 是否為負數
  let isNegative = rawVal < 0;
  rawVal = Math.abs(rawVal);

  // 分割 整數位 小數位
  let temp = String(rawVal),
    [intVal, doubleVal = ""] = temp.split(".");
  intVal = splitNumber(intVal);

  // 若小數位數不夠，補0
  let finalDouble = doubleVal;
  if (isZero && !decimalShowRaw && doubleVal.length < decimalCount) {
    for (let i = doubleVal.length; i < decimalCount; i++) finalDouble += "0";
  }

  let finalVal = intVal;
  if ((decimalCount > 0 || decimalShowRaw) && finalDouble)
    finalVal = intVal + "." + finalDouble;

  if (isNegative) finalVal = "-" + finalVal;

  return finalVal;
}

// 整理 Tree 層級資料
export const formatTreeData = ({
  module,
  key = "code",
  label = "label",
  childs,
} = {}) => {
  let tempData = [];
  childs.forEach(({ sub, ...item }) => {
    let children = [];

    if (sub) {
      children = formatTreeData({ module, key, label, childs: sub });
    }

    tempData.push(
      module === "table"
        ? {
            key: item[key],
            data: item,
            children,
          }
        : {
            key: item[key],
            label: item[label],
            data: item[label],
            children,
          }
    );
  });

  return tempData;
};

export const formatTime = (seconds) => {
  if (!seconds) return "";

  let hours = Math.floor(seconds / 3600),
    minutes = Math.floor((seconds % 3600) / 60);
  seconds = seconds % 60;

  const parts = [];
  if (hours > 0) parts.push(`${hours}時`);
  if (minutes > 0) parts.push(`${minutes}分`);
  if (seconds > 0) parts.push(`${seconds}秒`);

  return parts.join(" ");
};

export const formatFloorRoomSort = ({ data, key = null }) => {
  return data.sort(function (pre, next) {
    let valA = key ? pre[key] : pre,
      valB = key ? next[key] : next;

    // 數字開頭
    const numReg = /^\d/;
    const engReg = /^[a-zA-Z]/;
    const chiReg = /^[\u4e00-\u9fa5]/;

    const getType = (s) => {
      if (numReg.test(s)) return 0;
      if (engReg.test(s)) return 1;
      if (chiReg.test(s)) return 2;
      return 3;
    };

    const typeA = getType(valA);
    const typeB = getType(valB);

    if (typeA !== typeB) return typeA - typeB;

    // 同型態內：數字開頭用自然排序，其他直接 localeCompare
    if (typeA === 0) {
      // 取出前面的數字進行比較
      const numA = Number.parseInt(valA, 10);
      const numB = Number.parseInt(valB, 10);
      return numA - numB;
    }
    return valA.localeCompare(valB);
  });
};

const getDecimalLength = (value) => String(value).split(".")[1]?.length ?? 0;

// 浮點數相加
export const floatAdd = (arg1 = 0, arg2 = 0) => {
  const r1 = getDecimalLength(arg1);
  const r2 = getDecimalLength(arg2);
  const m = Math.pow(10, Math.max(r1, r2));
  return Number((floatMul(arg1, m) + floatMul(arg2, m)) / m);
};
// 浮點數相減
export const floatSubtraction = (arg1 = 0, arg2 = 0) => {
  const r1 = getDecimalLength(arg1);
  const r2 = getDecimalLength(arg2);
  const m = Math.pow(10, Math.max(r1, r2));
  const n = Math.max(r1, r2);
  return Number(((arg1 * m - arg2 * m) / m).toFixed(n));
};
// 浮點數相乘
export const floatMul = (arg1 = 0, arg2 = 0) => {
  let m = 0,
    s1 = String(arg1),
    s2 = String(arg2);
  m += getDecimalLength(arg1);
  m += getDecimalLength(arg2);
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
};
// 浮點數相除
export const floatDiv = (arg1 = 0, arg2 = 0) => {
  const t1 = getDecimalLength(arg1);
  const t2 = getDecimalLength(arg2);
  const r1 = Number(String(arg1).replace(".", ""));
  const r2 = Number(String(arg2).replace(".", ""));
  return (r1 / r2) * Math.pow(10, t2 - t1);
};

export const cleanFloat = (value, digits = 6) => {
  return Number(
    Math.round(value * Math.pow(10, digits)) / Math.pow(10, digits)
  );
};

export const delayAwait = (ms) => new Promise((res) => setTimeout(res, ms));

export const isExistDate = ({ date }) => {
  //列出12個月，每月最大日期限制
  const limitInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  const theYear = Number.parseInt(moment(date).format("YYYY"), 10);
  const theMonth = Number.parseInt(moment(date).format("MM"), 10);
  const theDay = Number.parseInt(moment(date).format("DD"), 10);
  const isLeap = new Date(theYear, 1, 29).getDate() === 29; // 是否為閏年?

  if (isLeap) {
    // 若為閏年，最大日期限制改為 29
    limitInMonth[1] = 29;
  }

  // 比對該日是否超過每個月份最大日期限制
  return theDay <= limitInMonth[theMonth - 1];
};

// 加密
export const handleEncrypt = ({ CRYPTO_KEY, text } = {}) => {
  const SHA256 = CryptoJS.SHA256(CRYPTO_KEY).toString(),
    MD5 = CryptoJS.MD5(CRYPTO_KEY).toString();
  return CryptoJS.AES.encrypt(text, CryptoJS.enc.Hex.parse(SHA256), {
    iv: CryptoJS.enc.Hex.parse(MD5),
  }).toString();
};

// 解密
export const handleDecrypt = ({ CRYPTO_KEY, text } = {}) => {
  const SHA256 = CryptoJS.SHA256(CRYPTO_KEY).toString(),
    MD5 = CryptoJS.MD5(CRYPTO_KEY).toString();
  return CryptoJS.AES.decrypt(text, CryptoJS.enc.Hex.parse(SHA256), {
    mode: CryptoJS.mode.CBC,
    iv: CryptoJS.enc.Hex.parse(MD5),
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
};

export const formatDateRange = ({ str }) => {
  if (str.startsWith("半尖峰")) return "半尖峰";
  if (str.startsWith("尖峰")) return "尖峰";
  if (str.startsWith("離峰")) return "離峰";
  return "其他";
};

export const formatEnergyDiff = ({ data }) => {
  // 先複製並排序（優先 TimeSlotNumber15，其次 time 字串）
  const sorted = [...data].sort((a, b) => {
    const timeSlotDiff = (a.TimeSlotNumber15 ?? 0) - (b.TimeSlotNumber15 ?? 0);
    if (timeSlotDiff !== 0) return timeSlotDiff;
    return String(a.LogPowerTime).localeCompare(String(b.LogPowerTime));
  });

  // 依 key 分組
  const groups = new Map(); // key = `${ComIP}|${RepeaterID}|${SlaveID}`
  for (const row of sorted) {
    const key = `${row.ComIP}|${row.RepeaterID}|${row.SlaveID}`;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(row);
  }

  // 逐組計算相鄰差
  const out = [];
  for (const rows of groups.values()) {
    for (let i = 1; i < rows.length; i++) {
      const prev = rows[i - 1];
      const curr = rows[i];

      const prevEndEnergy = Number.parseFloat(prev.endEnergy);
      const currEndEnergy = Number.parseFloat(curr.endEnergy);
      const prevEndPower = Number.parseFloat(prev.endPower);
      const currEndPower = Number.parseFloat(curr.endPower);
      if (
        Number.isNaN(prevEndEnergy) ||
        Number.isNaN(currEndEnergy) ||
        Number.isNaN(prevEndPower) ||
        Number.isNaN(currEndPower)
      )
        continue; // 跳過異常值

      out.push({
        ...curr,
        totalEnergy: +(currEndEnergy - prevEndEnergy).toFixed(6),
        totalPower: +(currEndPower - prevEndPower).toFixed(6),
        LogPowerTime: curr.LogPowerTime, // 取「後一筆」的 time
      });
    }
  }
  return out;
};
